const LISTICLE_CART_CLEAR_URL = `${window.Shopify?.routes?.root || '/'}cart/clear.js`;

async function clearCartWithRetry(retries = 2) {
  let lastError = null;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      const response = await fetch(LISTICLE_CART_CLEAR_URL, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Cart clear failed with status ${response.status}`);
      }

      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store'
      }).then((res) => res.json());

      if ((cart?.items || []).length === 0) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }

      throw new Error('Cart still contains items after clear');
    } catch (error) {
      lastError = error;
      if (attempt < retries) {
        await new Promise((resolve) => setTimeout(resolve, 150));
      }
    }
  }

  throw lastError;
}

window.addEventListener('pageshow', async (event) => {
  // Browser restored the page from history
  if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
    try {
      await clearCartWithRetry();
      console.log('Cart cleared');
    } catch (e) {
      console.error('Failed to clear cart on history navigation', e);
    }
  }
});